import React from "react";
import { Container, Button } from "shards-react";

const Errors = () => (
  <Container fluid className="main-content-container px-4 pb-4">
    <div className="error">
      <div className="error__content">
        <h2>400</h2>
        <h3>Bad Request</h3>
        <p>Sorry, the page you tried cannot be found.</p>
        <Button href="/" pill>&larr; Go Back</Button>
      </div>
    </div>
  </Container>
);

export default Errors;
